export default __webpack_public_path__ + "static/Gabby Juan-15860cecabd3fd51ac5b18441afe4548.png";